import { render, staticRenderFns } from "./PublicSmallCode.vue?vue&type=template&id=7af9a521&scoped=true"
import script from "./PublicSmallCode.vue?vue&type=script&lang=js"
export * from "./PublicSmallCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af9a521",
  null
  
)

export default component.exports